export default "__VITE_ASSET__33bca95e__"